<template>
  <v-card
    elevation="1"
    class="mt-0 py-lg-4"
    style="margin: 0 !important; position: relative"
  >
    <div
      v-if="showAlert"
      style="
        position: fixed;
        top: 10%;
        width: 50%;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        background-color: #2096f3;
        color: white;

        padding: 15px 20px;
        border-radius: 5px;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
        z-index: 1000;
        transition: opacity 0.5s ease, top 0.5s ease;
      "
    >
      <div class="d-flex align-center" style="width: 100%">
        <svg
          width="36px"
          height="36px"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          color="#ffffff"
          stroke-width="1.5"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM12 10.75C12.4142 10.75 12.75 11.0858 12.75 11.5V16.5C12.75 16.9142 12.4142 17.25 12 17.25C11.5858 17.25 11.25 16.9142 11.25 16.5V11.5C11.25 11.0858 11.5858 10.75 12 10.75ZM12.5675 8.00075C12.8446 7.69287 12.8196 7.21865 12.5117 6.94156C12.2038 6.66446 11.7296 6.68942 11.4525 6.99731L11.4425 7.00842C11.1654 7.3163 11.1904 7.79052 11.4983 8.06761C11.8062 8.34471 12.2804 8.31975 12.5575 8.01186L12.5675 8.00075Z"
            fill="#ffffff"
          ></path>
        </svg>
        <div style="margin-left: 24px">
          <div style="text-align: left; font-weight: 600">
            <p
              v-for="(line, index) in totalDataAlert"
              :key="index"
              style="margin-bottom: 0"
            >
              {{ line }}
            </p>
          </div>
          <div v-if="missingMessages.length > 0" class="mt-2">
            <p v-for="(message, index) in missingMessages" :key="index">
              {{ message }}
            </p>
          </div>
        </div>

        <v-btn
          style="
            text-transform: unset !important;
            background-color: white;
            padding: 1vh 1vh;
            border-radius: 30px !important;
            font-weight: bolder;
            font-size: medium;
            margin-left: 2%;
          "
          elevation="0"
          class="darken-1"
          type="submit"
          color="primary"
          @click="showAlert = false"
          >{{ $t("buttons.ok") }}</v-btn
        >
      </div>
    </div>

    <v-card-title style="color: var(--darkBlue)">
      <v-row>
        <v-col class="text-lg-left text-center d-flex align-center" cols="12">
          <div class="d-flex mb-2 mb-lg-0">
            <v-icon
              large
              class="mr-3"
              style="color: #0177d4 !important"
              id="menu-activator"
              @click="goBack"
            >
              mdi-arrow-left
            </v-icon>
            <h3>{{ item.ListName }}</h3>
          </div>
          <v-spacer />
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                style="font-size: 32px"
                v-bind="attrs"
                v-on="on"
                color="var(--primaryColor)"
                @click="
                  form = Object.assign({}, item);
                  updatePriceListModal = true;
                "
              >
                mdi-pencil
              </v-icon>
            </template>
            <span>{{ $t("buttons.update") }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-card-title>
    <v-divider />

    <v-dialog
      v-model="updatePriceListModal"
      v-if="updatePriceListModal"
      max-width="750"
    >
      <v-card class="popup-card" elevation="1">
        <v-card-title class="popupHeadline" style="font-size: 24px">
          <div class="text-center popupHeadline" style="width: 100%">
            {{ $t("buttons.update") }}
          </div>
        </v-card-title>
        <v-divider class="mb-4" />

        <ValidationObserver
          ref="updatePriceListObserver"
          v-slot="{ handleSubmit }"
        >
          <form @submit.prevent="handleSubmit(update)">
            <v-card-text>
              <FormElement
                v-for="(element, index) in formItems"
                :key="
                  element.key.parent + '_' + element.key.child + '_' + index
                "
                :vertical="element.vertical"
                v-model="$data[element.key.parent][element.key.child]"
                :validationLabel="$t(element.validationLabel)"
                :rules="element.rules"
                :formLabel="$t(element.formLabel)"
                :onChange="element.onChange"
                :formType="element.formType"
                :cols="element.cols"
                :sm="element.sm"
                :md="element.md"
                :lg="element.lg"
                :light="false"
                :hidden="element.hidden"
                :labelShown="element.labelShown"
                :topLabel="element.topLabel"
                :active="element.active"
                :disabled="element.disabled"
                :placeholder="$t(element.placeholder)"
                :classes="element.classes"
              />
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn
                style="
                  color: #fff;
                  text-transform: unset !important;
                  background-color: #0077d5;

                  padding: 1vh 1vh;
                  border-radius: 30px !important;
                  font-weight: bolder;
                  font-size: medium;
                "
                elevation="0"
                class="darken-1"
                type="submit"
                :loading="saveLoading"
                >{{ $t("buttons.save") }}</v-btn
              >
              <v-btn
                style="
                  color: #fff;
                  text-transform: unset !important;
                  background-color: var(--red);
                  padding: 1vh 1vh;
                  border-radius: 30px !important;
                  font-weight: bolder;
                  font-size: medium;
                "
                elevation="0"
                class="darken-1"
                @click="updatePriceListModal = false"
                >{{ $t("buttons.cancel") }}</v-btn
              >
            </v-card-actions>
          </form>
        </ValidationObserver>
      </v-card>
    </v-dialog>
    <ConfirmationModal
      v-model="confirmationModal"
      :title="$t('labels.warning')"
      :message="$t('messages.changeTheExcelFile')"
      :confirm="finishExcelFileOperation"
    />
    <v-card v-if="priceData && regionData" class="mt-5">
      <v-card-text style="padding: 0px; margin: 0px">
        <v-row class="px-4 pt-4">
          <FormElement
            key="ENTRY_REFERENCE_ID_2"
            :vertical="true"
            v-model="item.OptionalReferansId"
            :validationLabel="$t('labels.optionalReferenceID')"
            :topLabel="true"
            :labelShown="false"
            :cols="12"
            :sm="6"
            :md="4"
            :lg="3"
            :xl="2"
            disabled
            :placeholder="$t('labels.optionalReferenceID')"
          />
          <FormElement
            key="ENTRY_ID"
            :vertical="true"
            v-model="item.ReferanceId"
            :validationLabel="$t('labels.referenceId')"
            :topLabel="true"
            :labelShown="false"
            :cols="12"
            :sm="6"
            :md="4"
            :lg="3"
            :xl="2"
            :disabled="true"
            :formType="{
              name: 'text',
            }"
            :placeholder="$t('labels.referenceId')"
          />
          <FormElement
            key="ENTRY_VOLUME_DIVISOR"
            :vertical="true"
            v-model="item.VolumeDivisor"
            :validationLabel="$t('labels.volumeDivisor')"
            :topLabel="true"
            :labelShown="false"
            :cols="12"
            :sm="6"
            :md="4"
            :lg="3"
            :xl="2"
            :disabled="true"
            :formType="{
              name: 'text',
            }"
            :placeholder="$t('labels.volumeDivisor')"
          />
          <FormElement
            key="ENTRY_NAME"
            :vertical="true"
            v-model="item.ListName"
            :validationLabel="$t('labels.customerList')"
            rules="required"
            :topLabel="true"
            :labelShown="false"
            :cols="12"
            :sm="6"
            :md="4"
            :lg="3"
            :xl="2"
            :disabled="true"
            :formType="{
              name: 'text',
            }"
            :placeholder="$t('labels.customerList')"
          />

          <FormElement
            key="ENTRY_CARGO"
            :vertical="true"
            v-model="item.CargoName"
            :validationLabel="$t('labels.priceListName')"
            rules="required"
            :disabled="true"
            :topLabel="true"
            :labelShown="false"
            :active="isSupplier"
            :cols="12"
            :sm="6"
            :md="4"
            :lg="3"
            :xl="2"
            :formType="{
              name: 'text',
            }"
            :placeholder="$t('labels.priceListName')"
          />

          <FormElement
            key="ENTRY_COUNTRY"
            :vertical="true"
            v-model="regionData.Result.OriginCountry"
            :validationLabel="$t('labels.country')"
            rules="required"
            :topLabel="true"
            :labelShown="false"
            :cols="12"
            :sm="6"
            :md="4"
            :lg="3"
            :xl="2"
            :disabled="true"
            :formType="{
              name: 'text',
            }"
            :placeholder="$t('labels.country')"
          />

          <FormElement
            key="ENTRY_PORTAL_TYPE"
            :vertical="true"
            v-model="item.IntegrationLogistic"
            :validationLabel="$t('titles.subsupplier')"
            :topLabel="true"
            :labelShown="false"
            :cols="12"
            :sm="6"
            :md="4"
            :lg="3"
            :xl="2"
            :disabled="true"
            :formType="{
              name: 'text',
            }"
            :placeholder="$t('titles.subsupplier')"
          />
          <FormElement
            key="ENTRY_INTEGRATION_SERVICE"
            :vertical="true"
            v-model="item.IntegrationService"
            :validationLabel="$t('titles.integrationService')"
            :topLabel="true"
            :labelShown="false"
            :cols="12"
            :sm="6"
            :md="4"
            :lg="3"
            :xl="2"
            :disabled="true"
            :formType="{
              name: 'text',
            }"
            :placeholder="$t('titles.integrationService')"
          />
          <FormElement
            key="ENTRY_PORTAL_USERS"
            :vertical="true"
            v-model="item.PortalCompaniesString"
            :validationLabel="$t('labels.portalUsers')"
            :topLabel="true"
            :active="this.isSupplier"
            :labelShown="false"
            :cols="12"
            :sm="6"
            :md="4"
            :lg="3"
            :xl="2"
            :disabled="true"
            :formType="{
              name: 'text',
            }"
            :placeholder="$t('labels.portalUsers')"
          />
          <FormElement
            key="ENTRY_EXPIRY_DATE_START"
            :vertical="true"
            v-model="item.ValidityStartDate"
            :validationLabel="$t('labels.expiryDateStart')"
            rules="required"
            :topLabel="true"
            :labelShown="false"
            :disabled="true"
            :cols="12"
            :sm="6"
            :md="2"
            :lg="2"
            :xl="2"
            :formType="{
              name: 'date',
              dateMode: 'date',
            }"
            :placeholder="$t('labels.expiryDateStart')"
          />
          <FormElement
            key="ENTRY_EXPIRY_DATE_END"
            :vertical="true"
            v-model="item.ValidityEndDate"
            :validationLabel="$t('labels.expiryDateEnd')"
            rules="required"
            :topLabel="true"
            :labelShown="false"
            :disabled="true"
            :cols="12"
            :sm="6"
            :md="2"
            :lg="2"
            :xl="2"
            :formType="{
              name: 'date',
              dateMode: 'date',
            }"
            :placeholder="$t('labels.expiryDateEnd')"
          />

          <FormElement
            key="FSC_PERCENTAGE"
            :vertical="true"
            v-model="item.FscRate"
            rules="required|numeric|min_value:0|max_value:100"
            validationLabel="FSC"
            :topLabel="true"
            :labelShown="false"
            :cols="12"
            :sm="6"
            :md="4"
            :lg="2"
            :xl="2"
            :disabled="true"
            :formType="{
              name: 'text',
            }"
            placeholder="FSC"
          />
          <FormElement
            key="ACCOUNTS"
            :vertical="true"
            v-model="item.IntegrationLogisticAccount"
            :validationLabel="$t('labels.accounts')"
            :topLabel="true"
            :labelShown="false"
            :cols="12"
            :sm="6"
            :md="4"
            :lg="2"
            :xl="2"
            :disabled="true"
            :formType="{
              name: 'text',
            }"
            :placeholder="$t('labels.accounts')"
          />

          <FormElement
            key="MAX_KG"
            :vertical="true"
            v-model="item.ServiceMaxKg"
            rules="required|numeric|min_value:0|max_value:100"
            :validationLabel="$t('labels.maxKg')"
            :topLabel="true"
            :labelShown="false"
            :cols="12"
            :sm="6"
            :md="2"
            :lg="2"
            :xl="2"
            :disabled="true"
            :formType="{
              name: 'text',
            }"
            :placeholder="$t('labels.maxKg')"
          />
          <FormElement
            key="ENTRY_CURRENCY"
            :vertical="true"
            v-model="item.CurrencyCode"
            :validationLabel="$t('labels.currency')"
            rules="required"
            :topLabel="true"
            :labelShown="false"
            :cols="12"
            :sm="6"
            :md="2"
            :lg="2"
            :xl="2"
            :disabled="true"
            :formType="{
              name: 'text',
            }"
            :placeholder="$t('labels.currency')"
          />
        </v-row>

        <v-divider />
        <div style="position: relative; width: 100%">
          <!-- Prices tab için butonlar -->
          <div
            v-if="
              !(activeTab == 2) &&
              ($vuetify.breakpoint.xl ||
                $vuetify.breakpoint.lg ||
                $vuetify.breakpoint.md) &&
              isSupplier
            "
            class="d-flex mt-6 px-4"
            style="position: absolute; right: 0; top: 0; z-index: 1"
          >
            <v-btn
              style="border-radius: 12px !important"
              elevation="0"
              color="primary"
              class="button"
              dark
              :href="
                activeTab === 0
                  ? priceData?.Result?.FileUrl
                  : activeTab === 1
                  ? regionData?.Result?.FileUrl
                  : null
              "
              depressed
              download
              ><v-icon left> mdi-download </v-icon
              >{{ $t("buttons.downloadFile") }}</v-btn
            >
            <div class="ml-2">
              <v-btn
                style="border-radius: 12px !important"
                elevation="0"
                color="primary"
                class="button"
                dark
                depressed
                @click="onButtonClick"
              >
                <v-icon left> mdi-upload </v-icon>
                {{ $t("buttons.changeExcelFile") }}
              </v-btn>
              <input
                ref="uploader"
                class="d-none"
                type="file"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                @change="onFileChanged"
              />
            </div>
          </div>

          <div
            v-if="
              !(activeTab == 2) &&
              !(
                $vuetify.breakpoint.xl ||
                $vuetify.breakpoint.lg ||
                $vuetify.breakpoint.md
              )
            "
            class="d-flex mt-4 px-4"
            style="z-index: 1"
          >
            <v-btn
              style="border-radius: 12px !important"
              elevation="0"
              color="primary"
              class="button"
              dark
              :href="
                activeTab === 0
                  ? priceData?.Result?.FileUrl
                  : activeTab === 1
                  ? regionData?.Result?.FileUrl
                  : null
              "
              depressed
              download
              ><v-icon left> mdi-download </v-icon
              >{{ $t("buttons.downloadFile") }}</v-btn
            >
            <div class="ml-2">
              <v-btn
                style="border-radius: 12px !important"
                elevation="0"
                color="primary"
                class="button"
                dark
                depressed
                @click="onButtonClick"
              >
                <v-icon left> mdi-upload </v-icon>
                {{ $t("buttons.changeExcelFile") }}
              </v-btn>
              <input
                ref="uploader"
                class="d-none"
                type="file"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                @change="onFileChanged"
              />
            </div>
          </div>

          <!-- Costs tab için butonlar -->
          <div
            v-if="activeTab == 2 &&
              ($vuetify.breakpoint.xl ||
                $vuetify.breakpoint.lg ||
                $vuetify.breakpoint.md) &&
              isSupplier"
            class="d-flex mt-6 px-4"
            style="position: absolute; right: 0; top: 0; z-index: 1"
          >
            <v-btn
              style="border-radius: 12px !important"
              elevation="0"
              color="primary"
              class="button"
              dark
              :href="costData?.Result?.FileUrl"
              depressed
              download
            >
              <v-icon left> mdi-download </v-icon>
              {{ $t("buttons.downloadFile") }}
            </v-btn>
            <div class="ml-2">
              <v-btn
                style="border-radius: 12px !important"
                elevation="0"
                color="primary"
                class="button"
                dark
                depressed
                @click="onButtonClick"
              >
                <v-icon left> mdi-upload </v-icon>
                {{ $t("buttons.changeExcelFile") }}
              </v-btn>
              <input
                ref="uploader"
                class="d-none"
                type="file"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                @change="onFileChanged"
              />
            </div>
          </div>

          <div
            v-if="activeTab == 2 &&
              !($vuetify.breakpoint.xl ||
                $vuetify.breakpoint.lg ||
                $vuetify.breakpoint.md)"
            class="d-flex mt-4 px-4"
            style="z-index: 1"
          >
            <v-btn
              style="border-radius: 12px !important"
              elevation="0"
              color="primary"
              class="button"
              dark
              :href="costData?.Result?.FileUrl"
              depressed
              download
            >
              <v-icon left> mdi-download </v-icon>
              {{ $t("buttons.downloadFile") }}
            </v-btn>
            <div class="ml-2">
              <v-btn
                style="border-radius: 12px !important"
                elevation="0"
                color="primary"
                class="button"
                dark
                depressed
                @click="onButtonClick"
              >
                <v-icon left> mdi-upload </v-icon>
                {{ $t("buttons.changeExcelFile") }}
              </v-btn>
              <input
                ref="uploader"
                class="d-none"
                type="file"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                @change="onFileChanged"
              />
            </div>
          </div>

          <TabScreen
            :slots="slots"
            :changeIndexFunction="onTabChange"
            class="px-4 pt-4"
          >
            <template v-slot:prices>
              <div>
                <v-simple-table
                  v-if="priceData"
                  class="mb-4"
                  style="
                    border-collapse: collapse;
                    border-radius: 0;
                    border-style: solid;
                    border-bottom-width: 1px;
                    border-left-width: 2px;
                    border-right-width: 2px;
                    border-top-width: 0px;
                    border-color: lightgray;
                  "
                >
                  <thead
                    style="
                      border-style: solid;
                      border-top-width: 1px;
                      border-color: lightgray;
                    "
                  >
                    <tr>
                      <th class="text-center">Ağırlık/Bölge</th>
                      <th
                        v-for="(item, index) in priceData.Result.Headers"
                        :key="index"
                        class="text-center"
                      >
                        {{ item }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in priceData.Result.TableData"
                      :key="index"
                    >
                      <td
                        v-for="(value, valueIndex) in item"
                        :key="valueIndex"
                        class="text-center"
                      >
                        {{ value }}
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </div>
            </template>
            <template v-slot:regions>
              <div
                style="
                  border-radius: 0;
                  border-style: solid;
                  border-bottom-width: 1px;
                  border-left-width: 2px;
                  border-right-width: 2px;
                  border-top-width: 0px;
                  border-color: lightgray;
                "
              >
                <v-text-field
                  v-model="filterText"
                  :label="$t('labels.filterCountry')"
                  outlined
                  dense
                  clearable
                  class="mb-4"
                ></v-text-field>

                <v-data-table
                  :no-data-text="$t('messages.noData')"
                  @update:sort-desc="sort"
                  :headers="[
                    {
                      text: $t('labels.region'),
                      value: 'Region',
                      sortable: true,
                      groupable: false,
                      align: 'center',
                    },
                    {
                      text: $t('labels.country'),
                      value: 'Country',
                      sortable: true,
                      groupable: false,
                      align: 'center',
                    },
                    {
                      text: $t('titles.transferTime'),
                      value: 'TransportTime',
                      sortable: true,
                      groupable: false,
                      align: 'center',
                    },
                  ]"
                  :loading="$store.state.loadingStatus"
                  :options="{
                    itemsPerPage: itemsPerPage,
                    page: page,
                    sortBy: ['Region', 'DestinationCountry'],
                    sortDesc: [sortDesc],
                  }"
                  hide-default-footer
                  :items="filteredRegions"
                  :item-key="'DestinationCountry' + new Date().getTime()"
                >
                <template v-slot:item.Country="{ item }">
                  {{ item.OriginCountry || item.DestinationCountry }}
                </template>
                  <template v-slot:footer>
                    <div class="d-flex justify-center mt-8">
                      <v-row align="center" justify="center">
                        <v-col
                          v-if="
                            $vuetify.breakpoint.md ||
                            $vuetify.breakpoint.lg ||
                            $vuetify.breakpoint.xl
                          "
                          md="2"
                        ></v-col>
                        <v-col cols="9" sm="12" md="7" lg="7" xl="7">
                          <v-pagination
                            class="my-4"
                            @input="onPageChange"
                            :value="page"
                            :length="pageLength"
                            circle
                            :total-visible="$vuetify.breakpoint.xs ? 10 : 10"
                          ></v-pagination>
                        </v-col>
                        <v-col
                          cols="11"
                          sm="11"
                          md="3"
                          lg="3"
                          xl="3"
                          class="ml-md-auto d-flex align-center mb-6 mb-md-0 pr-3 pr-md-6"
                        >
                          <v-select
                            v-model="itemsPerPage"
                            :items="[5, 10, 15, 20, 50, 100, 1000]"
                            :label="$t('labels.selectItemsPerPage')"
                            item-value="value"
                            item-text="name"
                            outlined
                            dense
                            hide-details
                            @change="changeItemsPerPage"
                            rounded
                          >
                          </v-select>
                        </v-col>
                      </v-row>
                    </div>
                  </template>
                </v-data-table>
              </div>
            </template>
            <template v-slot:costs>
              <div>
                <v-simple-table
                  v-if="costData"
                  class="mb-4"
                  style="
                    border-collapse: collapse;
                    border-radius: 0;
                    border-style: solid;
                    border-bottom-width: 1px;
                    border-left-width: 2px;
                    border-right-width: 2px;
                    border-top-width: 0px;
                    border-color: lightgray;
                  "
                >
                  <thead
                    style="
                      border-style: solid;
                      border-top-width: 1px;
                      border-color: lightgray;
                    "
                  >
                    <tr>
                      <th class="text-center">Ağırlık/Bölge</th>
                      <th
                        v-for="(item, index) in costData.Result.Headers"
                        :key="index"
                        class="text-center"
                      >
                        {{ item }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in costData.Result.TableData"
                      :key="index"
                    >
                      <td
                        v-for="(value, valueIndex) in item"
                        :key="valueIndex"
                        class="text-center"
                      >
                        {{ value }}
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </div>
            </template>
          </TabScreen>
        </div>
      </v-card-text>
      <v-card-actions class="d-flex justify-center"> </v-card-actions>
    </v-card>
  </v-card>
</template>
<script>
import ExpressCargoServices from "../services/ExpressCargoServices";
import { getCurrencyTypes, ITEMS_PER_PAGE_OPTIONS } from "../utils/constants";
import FormElement from "../components/FormElement.vue";
import formatDate from "../utils/formatDate";
import TabScreen from "../components/TabScreen.vue";
import ConfirmationModal from "../components/General/ConfirmationModal.vue";
import PortalService from "../services/PortalService";
import IntegrationService from "../services/IntegrationService";

export default {
  data() {
    return {
      item: {
        isActive: false,
      },
      priceData: null,
      regionData: null,
      slots: [],
      isSelecting: false,
      file: null,
      selectedFiles: {
        priceExcel: null,
        regionExcel: null,
        costsExcel: null
      },
      activeTab: 0,
      page: 1,
      itemsPerPage: 10,

      confirmationModal: false,
      sortDesc: null,

      form: {},
      saveLoading: false,

      isSupplier: false,
      portalUsers: [],

      updatePriceListModal: false,
      filterText: "",
      showAlert: false,
      totalDataAlert: [],
      missingMessages: [],
      currencies: [],
      costData: null,
    };
  },
  components: { FormElement, TabScreen, ConfirmationModal },
  mounted() {
    this.isSupplier =
      this.$store.state.Type === "Supplier" ||
      this.$store.state.Type === "PendingSupplier";

    this.item = this.$route.params.item;
    console.log(this.item);
    if (!this.item) this.$router.push("price-chart-entry");
    else {
      this.getPortalUsers();
      this.getAccounts(this.item.IntegrationLogistic);

      this.item.isActive = !this.item.PriceListStatus;
      this.item.PortalCompaniesString = this.item.PortalCompanies.join(",");

      this.form = {
        ValidityStartDate: this.item.ValidityStartDate,
        ValidityEndDate: this.item.ValidityEndDate,
        FscRate: this.item.FscRate,
        ListName: this.item.ListName,
        PortalCompanyIds: this.item.PortalCompanyIds,
        CargoName: this.item.CargoName,
      };

      this.slots = [
        {
          name: "prices",
          title: this.$t("labels.priceList"),
          unSeenCount: 0,
        },
        {
          name: "regions",
          title: this.$t("labels.regionList"),
          unSeenCount: 0,
        }
      ];

      this.itemsPerPageOptions = ITEMS_PER_PAGE_OPTIONS;
      this.setup();
    }
  },
  watch: {},

  computed: {
    filteredRegions() {
      if (!this.filterText) {
        return this.regionData.Result.ExpressCargoRegions;
      }
      const filter = this.filterText
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
      return this.regionData.Result.ExpressCargoRegions.filter((region) =>
        region.DestinationCountry.toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .includes(filter)
      );
    },

    formItems() {
      return [
        {
          key: {
            parent: "form",
            child: "isActive",
          },
          active: this.item.PriceListStatus !== 2,
          validationLabel: "labels.isActive",
          formType: {
            name: "checkbox",
          },
          lg: 6,
          labelShown: false,
          topLabel: true,
          cols: 12,
          disabled: !this.isSupplier,
          placeholder: "labels.isActive",
          classes: "mb-4",
        },
        {
          key: {
            parent: "form",
            child: "OptionalReferansId",
          },
          validationLabel: "labels.optionalReferenceID",
          formType: {
            name: "text",
          },
          lg: 12,
          labelShown: false,
          topLabel: true,
          cols: 12,
          placeholder: "labels.optionalReferenceID",
        },
        {
          key: {
            parent: "form",
            child: "VolumeDivisor",
          },
          rules: "required|double|min_value:1",
          validationLabel: "labels.volumeDivisor",
          formType: {
            name: "text",
          },
          lg: 12,
          labelShown: false,
          topLabel: true,
          cols: 12,
          disabled: !this.isSupplier,
          placeholder: "labels.volumeDivisor",
        },
        {
          key: {
            parent: "form",
            child: "ListName",
          },
          validationLabel: "labels.customerList",
          formType: {
            name: "text",
          },
          lg: 12,
          labelShown: false,
          topLabel: true,
          cols: 12,
          disabled: !this.isSupplier,
          placeholder: "labels.customerList",
        },
        {
          key: {
            parent: "form",
            child: "CargoName",
          },
          validationLabel: "labels.priceListName",
          formType: {
            name: "text",
          },
          lg: 12,
          labelShown: false,
          topLabel: true,
          cols: 12,
          disabled: !this.isSupplier,
          placeholder: "labels.priceListName",
        },
        {
          key: {
            parent: "form",
            child: "ValidityStartDate",
          },
          validationLabel: "labels.expiryDateStart",
          formType: {
            name: "date",
            dateMode: "date",
          },
          lg: 12,
          labelShown: false,
          disabled: !this.isSupplier,
          topLabel: true,
          cols: 12,
          placeholder: "labels.expiryDateStart",
        },
        {
          key: {
            parent: "form",
            child: "ValidityEndDate",
          },
          validationLabel: "labels.expiryDateEnd",
          formType: {
            name: "date",
            dateMode: "date",
          },
          lg: 12,
          labelShown: false,
          disabled: !this.isSupplier,
          topLabel: true,
          cols: 12,
          placeholder: "labels.expiryDateEnd",
        },

        {
          key: {
            parent: "form",
            child: "CurrencyId",
          },
          rules: "required",
          validationLabel: "labels.currency",
          formType: {
            name: "multipleSelect",
            items: {
              data: this.currencies,
              value: "Id",
              text: "Code",
            },
          },
          lg: 12,
          labelShown: false,
          topLabel: true,
          cols: 12,
          disabled: !this.isSupplier,
          placeholder: "labels.currency",
        },

        {
          key: {
            parent: "form",
            child: "IntegrationLogisticId",
          },
          rules: "required",
          validationLabel: "labels.accounts",
          formType: {
            name: "multipleSelect",
            items: {
              data: this.accounts,
              value: "Id",
              text: "Name",
            },
          },
          lg: 12,
          labelShown: false,
          topLabel: true,
          cols: 12,
          disabled: !this.isSupplier,
          placeholder: "labels.accounts",
        },
        {
          key: {
            parent: "form",
            child: "PortalCompanyIds",
          },
          formType: {
            name: "checkTable",
            unselectedItems: this.portalUsers,
            selectedItems: this.form.PortalCompanyIds,
          },
          disabled: !this.isSupplier,
          labelShown: false,
        },
      ];
    },
    pageLength() {
      return Math.ceil(
        this.regionData.Result.ExpressCargoRegions.length / this.itemsPerPage
      );
    },
  },
  methods: {
    sort(item) {
      this.sortDesc = !!item;
    },
    goBack() {
      if (this.$router.getRoutes().length === 0) {
        this.$router.push({ name: "PriceChartEntry" });
      } else {
        this.$router.go(-1);
      }
    },
    onTabChange(index) {
      this.activeTab = index;
    },
    onButtonClick() {
      this.isSelecting = true;
      (this.file = null), (this.confirmationModal = false);
      window.addEventListener(
        "focus",
        () => {
          this.isSelecting = false;
        },
        { once: true }
      );

      this.$refs.uploader.click();
    },
    onFileChanged(e) {
      const file = e.target.files[0];
      if (file) {
        this.file = file;
        this.confirmationModal = true;
        e.target.value = "";
      }
    },
    finishExcelFileOperation() {
      let service = null,
        formData = new FormData(),
        finalService = null,
        willShowWarning = false;
      if (this.activeTab === 0) {
        service = ExpressCargoServices.updatePriceExcel;
        formData.append("PriceExcelId", this.item.PriceExcelId);
        finalService = this.getPriceExcel;
        this.selectedFiles.priceExcel = this.file;

        willShowWarning = true;
      } else if (this.activeTab === 1) {
        service = ExpressCargoServices.updateRegionExcel;
        formData.append("RegionExcelId", this.item.RegionExcelId);
        formData.append(
          "OriginCountryId",
          this.regionData.Result.OriginCountryId
        );
        finalService = this.getRegionExcel;
        this.selectedFiles.regionExcel = this.file;

        willShowWarning = true;
      } else if (this.activeTab === 2) {
        service = ExpressCargoServices.updateCostsExcelFile;
        formData.append("ExpressCargoRegionPriceId", this.item.Id);
        finalService = this.getCostsExcel;
        this.selectedFiles.costsExcel = this.file;
      }
      formData.append("File", this.file);

      if (service) {
        this.$store.state.loadingStatus = true;
        service(formData)
          .then((response) => {
            const data = response?.data?.Result;

            if(data?.CostExcelId){
              this.item.CostExcelId = data?.CostExcelId;
            }

            if(willShowWarning){
              const {
                PriceExcelNotInclude,
                RegionExcelNotInclude,
                TotalCountries,
                TotalRegions,
              } = data;

              this.totalDataAlert = [
                this.$t("labels.totalCountries", {
                  value: TotalCountries,
                }),
                this.$t("labels.totalRegions", {
                  value: TotalRegions,
                }),
              ];

              // Collect missing Excel messages
              let missingMessages = [];

              if (PriceExcelNotInclude.length > 0) {
                console.log("Price >>", PriceExcelNotInclude);
                missingMessages.push(
                  this.$t("labels.missingPriceExcel", {
                    value: PriceExcelNotInclude.join(", "),
                  })
                );
              }

              if (RegionExcelNotInclude.length > 0) {
                console.log("Region >>", RegionExcelNotInclude);
                missingMessages.push(
                  this.$t("labels.missingRegionExcel", {
                    value: RegionExcelNotInclude.join(", "),
                  })
                );
              }

              this.missingMessages = missingMessages;

              this.showAlert = true;
            }
            finalService();

            window.showSuccess(this.$t('messages.updatedSuccessfullyFile'))
          })
          .catch(window.showError)
          .finally(() => {
            this.$store.state.loadingStatus = false;
          });
      }
    },
    update() {
      this.$store.state.loadingStatus = true;
      this.saveLoading = true;

      let requestFunction = null,
        body = {
          RegionPriceListId: this.item.Id,
          isActive: this.form.isActive,
          OptionalReferansId: this.form.OptionalReferansId,
          ListName: this.form.ListName,
          ValidityStartDate: this.form.ValidityStartDate,
          ValidityEndDate: this.form.ValidityEndDate,
          PortalCompanyIds: this.form.PortalCompanyIds,
          CargoName: this.form.CargoName,
          IntegrationLogisticId: this.form.IntegrationLogisticId,
          CurrencyId: this.form.CurrencyId,
          VolumeDivisor: Number(this.form.VolumeDivisor),
        };
      requestFunction = ExpressCargoServices.updatePriceList;

      requestFunction(body)
        .then((response) => {
          window.showSuccess(this.$t("messages.updateActiveExpress"));
          const data = response.data.Result;

          this.form.PortalCompanies = data.PortalCompanyNames.split(",");
          this.form.PortalCompanyIds = data.PortalCompanyIds;
          this.form.PortalCompaniesString = data.PortalCompanyNames;

          this.item = Object.assign({}, this.form);
          this.updatePriceListModal = false;
        })
        .catch(window.showError)
        .finally(() => {
          this.$store.state.loadingStatus = false;
          this.saveLoading = false;
        });
    },

    getPortalUsers() {
      this.$store.state.loadingStatus = true;
      PortalService.getPortalUsers(null, null, null, null, 1, 999999999)
        .then((response) => {
          this.portalUsers = response.data.Result.PortalCompanies;
        })
        .catch(window.showError)
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },
    getAccounts(logisticId) {
      this.$store.state.loadingStatus = true;
      IntegrationService.getAccounts(logisticId)
        .then((response) => {
          this.accounts = response.data.Result;
        })
        .catch((error) => {})
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },

    /**
     * Format the date and returns it as a string.
     * @param {Date} date
     * @returns {string}
     */
    getFormattedDate(date) {
      return formatDate(date, "/");
    },

    changeItemsPerPage(newValue) {
      this.page = 1;
      this.itemsPerPage = newValue;
    },

    /**
     * Trigger when page changed.
     */
    onPageChange(newPage) {
      this.page = newPage;
    },

    getRegionExcel() {
      ExpressCargoServices.getRegionExcel({Id: this.item.RegionExcelId, ExportImportType: this.item.ExportImportType })
        .then((response) => {
          this.regionData = response?.data;
        })
        .catch(window.showError)
        .finally(() => {});
    },
    getPriceExcel() {
      ExpressCargoServices.getPriceExcel(this.item.PriceExcelId)
        .then((response) => {
          this.priceData = response?.data;
        })
        .catch(window.showError)
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },
    getCostsExcel() {
      if(!this.item.CostExcelId) return;
      ExpressCargoServices.getCostsExcel(this.item.CostExcelId)
        .then((response) => {
          this.costData = response?.data;
        })
        .catch(window.showError)
        .finally(() => {});
    },
    async setup() {
      // Getting Excel
      this.getRegionExcel();
      this.getPriceExcel();


      if(this.isSupplier){
        this.slots.push({
          name: "costs",
          title: this.$t("labels.costList"),
          unSeenCount: 0,
        })

        this.getCostsExcel();
      }

      this.currencies = await getCurrencyTypes()
    },
  },
};
</script>
<style>
.container {
  margin-top: 38px;
}

.offerFormSheet {
  padding: 30px;
}

.activeRadioButton {
  color: var(--pink) !important;
}

.color-pink {
  color: var(--pink) !important;
  font-weight: bold;
}

.bold-cell {
  font-weight: bold;
}

.regular-cell {
  color: #575454;
}
</style>
